import React from 'react';

import AuthActions from 'auth/AuthActions';
import ChatActions from 'chat/actions/ChatActions';
import ChatStore from 'chat/stores/ChatStore';
import CurrentUser from 'auth/CurrentUser';
import ErrorActions from 'actions/ErrorActions';
import jwt from 'lib/jsonwebtoken';
import UserActions from 'user/UserActions';

import ReportChatModal from './ReportChatModal.jsx';

import './styles/ReportChatView.scss';

class ReportChatView extends React.Component {
  static onEnter(nextState, replaceWith, callback) {
    AuthActions.jwtTokenSignIn(nextState.params.token);
    const payload = jwt.decode(CurrentUser.getToken());
    if (Object.keys(payload).length > 0) {
      UserActions.loadCurrentUser(nextState.params.token).then(() => {
        ChatActions.loadChat(payload.chat_uuid).then(
          () => {
            callback();
          },
          () => {
            replaceWith('/error');
            callback();
          }
        );
      }, () => {
        ErrorActions.expiredToken('REPORT_CHAT');
        replaceWith('/error');
        callback();
      });
    } else {
      ErrorActions.unknownToken('REPORT_CHAT');
      replaceWith('/error');
      callback();
    }
  }

  // $FlowFixMe
  constructor(props) {
    super(props);
    const payload = jwt.decode(CurrentUser.getToken());
    const chat = ChatStore.getChat(payload.chat_uuid);
    const partner = chat.getMemberships().filter(membership => {
      return membership.getMember().getUuid() === payload.sender.id;
    })[0].getMember();

    this.state = {
      chat,
      partner,
    };
  }

  render() {
    return (
      <div className="ReportChatView">
        <div className="ReportChatView-wrap">
          <ReportChatModal
            className="ReportChatView-modal"
            chat={this.state.chat}
            partner={this.state.partner}
          />
        </div>
      </div>
    );
  }
}

export default ReportChatView;



// WEBPACK FOOTER //
// ./src/chat/components/ReportChatView.jsx